import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AssessmentComparisonPage } from '@/pages/assessment/ui/AssessmentComparisonPage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const assessmentComparisonSearchSchema = z.object({
  amount_unit: z.enum(amountUnitValues).optional(),
});

export const Route = createFileRoute('/_protected/assessment/$assessmentId/')({
  component: AssessmentComparisonPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: assessmentComparisonSearchSchema,
      defaultValues: undefined,
    }),
});
